import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Trophy, Star, Flag } from "lucide-react";

const iconMap = { sparkles: Sparkles, trophy: Trophy, star: Star, flag: Flag };

export default function AchievementsTimeline({ items, content }) {
  return (
    <section id="achievements" data-testid="achievements-section" className="py-20 bg-[#120908]">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-14">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">MILESTONES</div>
          <h2 className="section-title text-3xl sm:text-4xl">{content.titles.achievements}</h2>
          <p className="text-[#A89A88] mt-3 text-sm">لحظات صنعها الفريق على الخشبة وخارجها.</p>
        </div>

        {items.length === 0 ? (
          <p className="text-center text-[#A89A88]">لا توجد إنجازات مضافة بعد.</p>
        ) : (
          <div className="relative">
          <div className="absolute right-6 md:right-1/2 top-0 bottom-0 w-px timeline-line" />
            <div className="space-y-8">
              {items.map((it, i) => {
                const Icon = iconMap[it.icon] || Trophy;
                const isLeft = i % 2 === 0;
                return (
                  <motion.div
                    key={it.id}
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    data-testid={`achievement-${it.id}`}
                    className={`relative flex ${isLeft ? "md:justify-start" : "md:justify-end"}`}
                  >
                    <div className="absolute right-6 md:right-1/2 md:translate-x-1/2 w-4 h-4 rounded-full bg-[#F0E8DB] border-4 border-[#1A0F0E] mt-3" />
                    <div className={`w-full mr-14 md:mr-0 md:w-5/12 ${isLeft ? "md:ml-auto md:pl-10" : "md:pr-10"}`}>
                      <div className="theater-card rounded-xl p-5">
                        <div className="flex items-center gap-3 mb-2">
                          <div className="w-9 h-9 rounded-lg bg-[#7A2E2A]/40 border border-[#F0E8DB]/40 flex items-center justify-center text-[#F0E8DB]">
                            <Icon size={16} />
                          </div>
                          <div className="text-[#F0E8DB] text-xs font-serif-en">{it.date}</div>
                        </div>
                        <h3 className="text-[#F0E8DB] font-semibold text-lg">{it.title}</h3>
                        <p className="text-[#A89A88] text-sm mt-1">{it.description}</p>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
